import DefaultButton from './DefaultButton';
import { GetDefaultButtonCostume } from '../hud/HudConstants';

/*

    There's always an exception..everywhere  ( that's probably on the toy tory meme with buzz and woody )

    anyhoo - so sound button need to use different textures based on sound availablity
    so extending the default button class and just overriding the frame data as needed :)

*/
export default class SoundButton extends DefaultButton {
  constructor({ game }) {
    super({ game, id: 'sound' });

    this.onInputDown.add(this.handleInputDown, this);
    this.updateFrames();
  }

  handleInputDown() {
    this.game.sounds.allowMusic = this.game.sounds.allowMusic == false;
    this.game.sounds.allowEffects = this.game.sounds.allowEffects == false;
    this.updateFrames();
  }

  updateFrames() {
    const costume = GetDefaultButtonCostume(this.game.sounds.allowMusic ? 'soundon' : 'soundoff');
    this.setFrames(costume.over, costume.up, costume.down, costume.up);
  }

  destroy() {
    this.onInputDown.remove(this.handleInputDown, this);
    super.destroy(true);
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/buttons/SoundButton.js